<template>
  <div>
    <!-- line 1 -->
    <div class="mb-3">
      <Dairy_quests/>
    </div>
    <!-- line 2 -->
    <div class="mb-3">
      <Monthlybillpayment/>
    </div>
    <!-- line 3 -->
    <div class="mb-3">
      <Summary_total_sale/>
    </div>
    <!-- line 4 -->
    <div class="mb-3">
      <Total_sell_member/>
    </div>
    <!-- line 5 -->
    <div class="mb-3">
      <Cost_per_month/>
    </div>
    <!-- line 6 -->
    <div class="mb-3">
      <Customer_product_all/>
    </div>
    <!-- line 7 -->
    <div class="mb-3">
      <Expired_product/>
    </div>
    <!-- line 8 -->
    <div class="mb-3">
      <Supplier_total/>
    </div>
    <!-- line 9 -->
    <div class="mb-3">
      <Top_ten_product/>
    </div>
    <!-- line 10 -->
    <div class="mb-3">
      <Creditor_stand/>
    </div>
    <!-- line 11 -->
    <div class="mb-3">
      <View_total/>
    </div>
  </div>
</template>
<script>
import Top_ten_product from "@/components/admin/Report_main/Top_ten_product";
import Creditor_stand from "@/components/admin/Report_main/Creditor_stand";
import View_total from "@/components/admin/Report_main/View_total";
import Summary_total_sale from "@/components/admin/Report_main/Summary_total_sale";
import Dairy_quests from "@/components/admin/Report_main/Dairy_quests";
import Monthlybillpayment from "@/components/admin/Report_main/Monthlybillpayment";
import Total_sell_member from "@/components/admin/Report_main/Total_sell_member";
import Cost_per_month from "@/components/admin/Report_main/Cost_per_month";
import Customer_product_all from "@/components/admin/Report_main/Customer_product_all";
import Expired_product from "@/components/admin/Report_main/Expired_product";
import Supplier_total from "@/components/admin/Report_main/Supplier_total";

export default {
  components: {
    Supplier_total,
    Expired_product,
    Customer_product_all,
    Cost_per_month,
    Total_sell_member,
    Dairy_quests,
    Monthlybillpayment,
    Summary_total_sale,
    View_total,
    Creditor_stand,
    Top_ten_product
  },
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Report",
}
</script>
<style scoped>

</style>
